// Clone any object
export let clone = (object:any):any => {

    if (object === null || object === undefined)
        return null;
        
    let clone = JSON.parse(JSON.stringify(object));
    return clone;

};


// WEBPACK FOOTER //
// ./source/ts/helpers/clone.ts